// Category Type Keys
export const CATEGORY_TYPES = {
  ISSUE_TYPE: "IssueType",
  PRIORITY: "Priority",
  STATUS: "Status",
  UNCATEGORIZED: "Uncategorized",

};

// Category Type Keys (lowercase for matching) - for AddConfig.js includes() checks
export const CATEGORY_TYPE_LOWERCASE = {
  ISSUE: "issue",
  PRIORITY: "priority",
  STATUS: "status",
};

// Active Tab Values - exact values used in catagoryContanier.js
export const ACTIVE_TAB_VALUES = {
  ISSUE_TYPE: "issueType",
  PRIORITY: "priority",
  STATUS: "status",
};

// Data Property Names
export const DATA_PROPERTIES = {
  ISSUE_TYPES: "issueTypes",
  PRIORITY_TYPE: "priorityType",
  STATUS_TYPE: "statusType",
};


// Display Labels
export const DISPLAY_LABELS = {
  ISSUE_TYPE: "Issue Type",
  PRIORITY: "Priority",
  STATUS: "Status",
};
